module.exports = __webpack_public_path__ + "img/smartTv.db3e2cd1.jpg";